



















































import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { loadStripe } from '@stripe/stripe-js';
import { Booking, Payment } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) readonly booking: Booking;
  @Prop({ required: true }) readonly amount: number;

  valid: boolean = false;
  loading: boolean = false;
  paymentLoading: boolean = false;

  payment: Payment | null = null;

  errorMessage: string | null = null;

  style: any = {
    base: {
      color: '#32325d',
      fontFamily:
        "'Cooper Hewitt', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  };

  stripe: any;
  card: any;

  handleCardErrors() {
    this.card.on('change', (e: any) => {
      if (e.error) {
        this.errorMessage = e.error.message;
      } else {
        this.errorMessage = null;
      }
    });
  }

  close() {
    this.$emit('close-payment');
  }

  async doPayment() {
    if (!this.booking || !this.payment) {
      return;
    }

    try {
      this.paymentLoading = true;
      const { paymentIntent, error } = await this.stripe.confirmCardPayment(
        this.payment.clientSecret,
        {
          payment_method: {
            card: this.card,
            billing_details: {
              email: this.booking.email,
              name: `${this.booking.firstName} ${this.booking.lastName}`,
              phone: this.booking.phoneNumber,
            },
          },
        },
      );
      if (error) {
        throw error;
      }
      this.errorMessage = null;
      this.$emit('payment-success');
    } catch (err) {
      // Error
      this.errorMessage = err.message;
    } finally {
      this.paymentLoading = false;
    }
  }

  async mounted() {
    try {
      this.loading = true;
      this.payment = new Payment({
        amount: this.amount,
        booking: this.booking,
      });
      await this.payment.save({ with: ['booking.id'] });
      this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_API_KEY);

      const elements = this.stripe.elements();

      this.card = elements.create('card', { style: this.style });
      this.handleCardErrors();

      this.card.mount('#card-element');
    } catch (err) {
      // Error
      this.errorMessage = err.response.errors[0].detail;
    } finally {
      this.loading = false;
    }
  }
}
